var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"check__container"},[_c('div',[_c('fa-icon',{staticClass:"check",attrs:{"icon":"check-circle"}}),_c('h2',[_vm._v("Bra!")])],1),_c('h5',[_vm._v("NXT är för dig!")])])}
var staticRenderFns = []

export { render, staticRenderFns }